import React, {useMemo} from 'react';
import 'dayjs/locale/it';
import type {PropsWithChildren} from 'react';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {useTranslation} from 'react-i18next';

const LocalizationProviderMUI = ({children}: PropsWithChildren) => {
  const {t} = useTranslation();

  const dateFormats = useMemo(
    () => ({
      fullDate: t('DatePickerMUI.dateFormat'),
      keyboardDate: t('DatePickerMUI.dateFormat'),
    }),
    [t],
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} dateFormats={dateFormats}>
      {children}
    </LocalizationProvider>
  );
};

export default React.memo(LocalizationProviderMUI);
